module.exports = __webpack_public_path__ + "img/entrance_to_the_chamber_of_secrets.d55d560b.jpg";